import Dropdown from "../../components/base/dropdown";
import SearchField from "./search-field";
import { throttle } from "../../lib";
import MobileMenu from "./mobile-menu";

class SiteHeaderDesktop {
    constructor() {
        this.$root = document.querySelector('.site-header');

        this.initHeaderDropdowns();
        this.initSearchField();
        this.initPinnedHeader();
    }

    initHeaderDropdowns() {
        const dropdowns = [];
        const $triggers = this.$root.querySelectorAll('[data-dropdown-trigger]');

        if (!$triggers.length) {
            return;
        }

        $triggers.forEach(($trigger) => {
            const $menu = this.$root.querySelector(`[data-dropdown-menu="${$trigger.dataset.dropdownTrigger}"]`);

            if ($menu != null) {
                dropdowns.push(new Dropdown($menu, $trigger, {
                    subscriptions: [
                        {
                            event: 'beforeShow',
                            callback: () => {
                                /* Hide all shown dropdowns before to show current */
                                dropdowns.forEach((dropdown) => {
                                    if (dropdown.visible) {
                                        dropdown.hide();
                                    }
                                });
                            }
                        },
                    ]
                }));
            }
        });
    }

    initSearchField() {
        const searchField = new SearchField();
    }

    initPinnedHeader() {
        window.addEventListener('scroll', throttle(() => {
            if (window.scrollY > 115) {
                document.body.classList.add('-pinned-header');
            } else {
                document.body.classList.remove('-pinned-header');
            }
        }, 20));
    }
}

class SiteHeaderMobile {
    constructor() {
        this.initMobileMenu();
    }

    initMobileMenu() {
        const mobileMenu = new MobileMenu();
    }
}

export default class SiteHeader {
    constructor() {
        this.desktopModule = null;
        this.mobileModule = null;

        this.media = window.matchMedia('(min-width: 769px)').matches;

        this.init();
    }

    init() {
        if (this.media && !this.desktopModule) {
            this.desktopModule = new SiteHeaderDesktop();
        } else if (!this.media && !this.mobileModule) {
            this.mobileModule = new SiteHeaderMobile();
        }

        window.addEventListener('resize', throttle(() => {
            this.media = window.matchMedia('(min-width: 769px)').matches;

            if (this.media && !this.desktopModule) {
                this.desktopModule = new SiteHeaderDesktop();
            } else if (!this.media && !this.mobileModule) {
                this.mobileModule = new SiteHeaderMobile();
            }
        }, 20));
    }
}